export default __webpack_public_path__ + "static/404-c463618ff236c2e833ac170f77cb388b.webp";